import AttendanceIconFilled from "assets/img/Sidebar/Repositioning/Attendance_filled.svg";
import ClockInOutIconFilled from "assets/img/Sidebar/Repositioning/Attendance_filled.svg";
import AttendanceIconLine from "assets/img/Sidebar/Repositioning/Attendance_line.svg";
import ClockInOutIconLine from "assets/img/Sidebar/Repositioning/Attendance_line.svg";
import ClientsIconFilled from "assets/img/Sidebar/Repositioning/Customer_filled.svg";
import ClientsIconLine from "assets/img/Sidebar/Repositioning/Customer_line.svg";
import DashboardIconFilled from "assets/img/Sidebar/Repositioning/Dashboard_Filled.svg";
import DashboardIconLine from "assets/img/Sidebar/Repositioning/Dashboard_Line.svg";
import GPSTrackIconFilled from "assets/img/Sidebar/Repositioning/GPS_tracking_filled.svg";
import GPSTrackIconLine from "assets/img/Sidebar/Repositioning/GPS_tracking_line.svg";
import IntegrationsIconFilled from "assets/img/Sidebar/Repositioning/Integration_Filled.svg";
import IntegrationsIconLine from "assets/img/Sidebar/Repositioning/Integration_Line.svg";
import InvoiceIconFilled from "assets/img/Sidebar/Repositioning/Invoice_Filled.svg";
import InvoiceIconLine from "assets/img/Sidebar/Repositioning/Invoice_Line.svg";
import MembersIconFilled from "assets/img/Sidebar/Repositioning/Member_Filled.svg";
import MembersIconLine from "assets/img/Sidebar/Repositioning/Member_Line.svg";
import OfficesIconFilled from "assets/img/Sidebar/Repositioning/Office_filled.svg";
import TeamsIconFilled from "assets/img/Sidebar/Repositioning/Office_filled.svg";
import OfficesIconLine from "assets/img/Sidebar/Repositioning/Office_line.svg";
import TeamsIconLine from "assets/img/Sidebar/Repositioning/Office_line.svg";
import OrganizationsIconFilled from "assets/img/Sidebar/Repositioning/Organization_Filled.svg";
import OrganizationsIconLine from "assets/img/Sidebar/Repositioning/Organization_Line.svg";
import PayrollIconLine from "assets/img/Sidebar/Repositioning/Payroll_Line.svg";
import PayrollIconFilled from "assets/img/Sidebar/Repositioning/Payroll_filled.svg";
import ProjectsIconFilled from "assets/img/Sidebar/Repositioning/Project_Filled.svg";
import ProjectsIconLine from "assets/img/Sidebar/Repositioning/Project_Line.svg";
import QuickActionsIconFilled from "assets/img/Sidebar/Repositioning/Quick_Actions_Filled.svg";
import QuickActionsIconLine from "assets/img/Sidebar/Repositioning/Quick_Actions_Line.svg";
import RouteOptimizationIconFilled from "assets/img/Sidebar/Repositioning/Route_filled.svg";
import RouteOptimizationIconLine from "assets/img/Sidebar/Repositioning/Route_line.svg";
import SchedulesIconFilled from "assets/img/Sidebar/Repositioning/Scheduling_Filled.svg";
import SchedulesIconLine from "assets/img/Sidebar/Repositioning/Scheduling_Line.svg";
import SettingsIconFilled from "assets/img/Sidebar/Repositioning/Settings_Filled.svg";
import SettingsIconLine from "assets/img/Sidebar/Repositioning/Settings_Line.svg";
import TasksIconFilled from "assets/img/Sidebar/Repositioning/Task_Filled.svg";
import TasksIconLine from "assets/img/Sidebar/Repositioning/Task_Line.svg";
import TimesheetIconFilled from "assets/img/Sidebar/Repositioning/Timesheet_filled.svg";
import TimesheetIconLine from "assets/img/Sidebar/Repositioning/Timesheet_line.svg";
import WorkOrderIconFilled from "assets/img/Sidebar/Repositioning/Work_order_Filled.svg";
import WorkOrderIconLine from "assets/img/Sidebar/Repositioning/Work_order_Line.svg";
import DesktopAppIcon from "assets/img/Sidebar/desktop.svg";
import HelpIcon from "assets/img/Sidebar/help.svg";
import MobileAppIcon from "assets/img/Sidebar/mobile.svg";
import PublicApiIcon from "assets/img/Sidebar/public_api_icon.svg";
import ReadBlogIcon from "assets/img/Sidebar/read-blog.svg";
import RemoteTrackIcon from "assets/img/Sidebar/remote-track.svg";
import ReportsIcon from "assets/img/Sidebar/reports.svg";
import arrowDown from "assets/img/Sidebar/sidebar-arrow-down.svg";
import arrowUp from "assets/img/Sidebar/sidebar-arrow-up.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { PulsatingDot } from "../LiveFeed/CurrentlyTracking/CurrentlyTracking";
import {
  CollapseArrowIcon,
  CollapseLinkIcon,
  CollapseLinkText,
  LinkIcon,
  LinkText,
  NewBadge,
  SeeMoreArrow,
  SeeMoreContainer,
  SeeMoreDiv,
  SidebarCollapseList,
  SidebarCollapseListItem,
  SidebarLink,
  SidebarLinkCollapse,
  SidebarListItem,
  SingleCollapseLinkContainer,
  SingleLinkContainer,
} from "./sidebarStyles";

const seeMoreData = [
  // {
  //   name: "Invite Member",
  //   link: "/user/member-invitation",
  //   icon: InviteMemberIcon,
  //   isExternal: false,
  //   Highlight: false,
  // },
  // {
  //   name: 'Desktop App',
  //   link: 'https://apploye.com/download',
  //   icon: DesktopAppIcon,
  //   isExternal: true,
  // },
  {
    name: "Mobile App",
    link: "https://www.fieldservicely.com/download",
    icon: MobileAppIcon,
    isExternal: true,
    Highlight: false,
  },
  // {
  //   name: 'Public API',
  //   link: '/user/public-api',
  //   icon: PublicApiIcon,
  //   isExternal: false,
  //   new: true,
  // },
  // {
  //   name: 'Read Blog',
  //   link: 'https://apploye.com/blog/',
  //   icon: ReadBlogIcon,
  //   isExternal: true,
  // },
  // {
  //   name: 'Help',
  //   link: 'https://apploye.com/help/',
  //   icon: HelpIcon,
  //   isExternal: true,
  // },
];

const activeRoute = (routeName, location) => {
  if (
    routeName === "/user/settings" &&
    (location.pathname === "/user/current-plan" ||
      location.pathname === "/user/subscription" ||
      location.pathname === "/user/activity-settings" ||
      location.pathname === "/user/timesheet-settings")
  ) {
    return true;
  } else if (
    routeName === "/user/projects" &&
    (location.pathname === "/user/create-project" ||
      location.pathname === "/user/edit-project" ||
      location.pathname === "/user/project-details")
  ) {
    return true;
  } else if (
    routeName === "/user/live-feed" &&
    location.pathname === "/user/instant-screenshots"
  ) {
    return true;
  } else if (
    routeName === "/user/organizations" &&
    location.pathname === "/user/add-organization"
  ) {
    return true;
  } else if (
    routeName === "/user/customers" &&
    (location.pathname === "/user/add-customer" ||
      location.pathname === "/user/edit-customer" ||
      location.pathname === "/user/customer-details")
  ) {
    return true;
  } else if (
    routeName === "/user/members" &&
    (location.pathname === "/user/member-details" ||
      location.pathname === "/user/member-invitation" ||
      location.pathname === "/user/member-invitationCSV")
  ) {
    return true;
  } else if (
    routeName === "/user/jobs" &&
    (location.pathname === "/user/job-details" ||
      location.pathname === "/user/create-job" ||
      location.pathname === "/user/edit-job")
  ) {
    return true;
  } else if (
    routeName === "/user/teams" &&
    (location.pathname === "/user/add-team" ||
      location.pathname === "/user/team-details")
  ) {
    return true;
  } else if (
    routeName === "/user/project" &&
    (location.pathname === "/user/create-project" ||
      location.pathname === "/user/edit-project" ||
      location.pathname === "/user/details-project")
  ) {
    return true;
  } else if (
    routeName === "/user/job" &&
    (location.pathname === "/user/create-job" ||
      location.pathname === "/user/edit-job" ||
      location.pathname === "/user/details-job")
  ) {
    return true;
  } else if (
    routeName === "/user/teams" &&
    (location.pathname === "/user/add-team" ||
      location.pathname === "/user/team-details")
  ) {
    return true;
  } else if (
    routeName === "/user/invoices" &&
    (location.pathname === "/user/create-invoice" ||
      location.pathname === "/user/edit-invoice" ||
      location.pathname === "/user/invoice-preview" ||
      location.pathname === "/user/invoice-client-view")
  ) {
    return true;
  } else if (
    routeName === "/user/integrations" &&
    location.pathname === "/user/ghl-settings/"
  ) {
    return true;
  } else {
    // Exact match for the route itself
    if (location.pathname === routeName) {
      return true;
    }
    // For routes with sub-paths, only match known sub-paths
    // Don't use indexOf as it causes false positives (e.g., /user/jobs-in-map matches /user/jobs)
    return false;
  }
};

export const generateGroupedLinks = (routes, organization) => {
  const sidebarGroupedLinks = {
    Common: [],
    "Crew Management": [],
    "Client Management": [],
    Admin: [],
  };

  if (
    organization &&
    organization.plan &&
    organization.plan.name === "Standard" &&
    organization.plan.nick_name === "standard-free"
  ) {
    delete sidebarGroupedLinks["Client Management"];
  }

  const viewerRole = localStorage.getItem("viewer_role");
  const paths = [...routes];
  paths.map((path, key) => {
    if (
      path.redirect ||
      (organization &&
        organization.role === "member" &&
        (path.name === "Invoice" ||
          // path.name === "Work Order" ||
          path.name === "Dashboard" ||
          path.name === "Customers" ||
          path.name === "Organizations" ||
          path.name === "Payroll" ||
          path.name === "Integrations" ||
          path.name === "Settings" ||
          path.name === "Live Feed" ||
          // path.name === "Project" ||
          // path.name === "Tasks" ||
          // path.name === "Teams" ||
          path.name === "Offices" ||
          path.name === "Schedules" ||
          path.name === "GPS Tracking"))
    ) {
      return null;
    }
    if (
      organization &&
      organization.plan &&
      organization.plan.name === "Standard" &&
      organization.plan.nick_name === "standard-free" &&
      (path.name === "Invoice" ||
        path.name === "Work Order" ||
        path.name === "Customers" ||
        path.name === "Jobs" ||
        path.name === "Job Approval" ||
        path.name === "Projects" ||
        path.name === "Tasks" ||
        path.name === "Teams" ||
        path.name === "Offices" ||
        path.name === "Schedules" ||
        path.name === "GPS Tracking")
    ) {
      return null;
    }
    // Check if path.group exists and is a valid key in sidebarGroupedLinks
    if (path.group && sidebarGroupedLinks[path.group]) {
      sidebarGroupedLinks[path.group].push(path);
    }
  });
  return sidebarGroupedLinks;
};
// this verifies if any of the collapses should be default opened on a rerender of this component
// for example, on the refresh of the page,
// while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
const getCollapseInitialState = routes => {
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
      return true;
    } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
      return true;
    }
  }
  return false;
};

// this checks if any route under the parent route is active if the path contains collapse
const checkCollapsePathActiveRoutes = (location, activeRoutes) => {
  if (!activeRoutes.length) return false;
  if (activeRoutes.includes(location.pathname)) {
    return true;
  }
  return false;
};

// this creates the intial state of this component based on the collapse routes
// that it gets through this.props.routes
export const getCollapsedStates = routes => {
  let initialState = {};
  routes.map((path, key) => {
    if (path.collapse) {
      initialState = {
        [path.state]: getCollapseInitialState(path.views),
        ...getCollapsedStates(path.views),
        ...initialState,
      };
    }
    return null;
  });
  return initialState;
};

const getCollapseLinks = (
  organization,
  views,
  location,
  sidebarMini,
  t,
  handleNavOpen,
) => {
  return views.map((view, index) => {
    if (
      organization &&
      organization.plan &&
      organization.plan.screenshot_track === false &&
      view.monitored
    ) {
      return null;
    }
    // else if (
    //   organization &&
    //   organization.plan &&
    //   organization.plan.name === "Standard" &&
    //   (view.name === "Customers" ||
    //     view.name === "Work Order" ||
    //     view.name === "All Jobs" ||
    //     view.name === "Invoice")
    // ) {
    //   return null;
    // }
    //  else if (
    //   view.name === "Route Map" &&
    //   organization &&
    //   organization.configuration &&
    //   !organization.configuration.location_track
    // ) {
    //   return null;
    // } else if (
    //   (view.name === "Job Sites" || view.name === "Geofence Clock In/Out") &&
    //   organization &&
    //   organization.configuration &&
    //   !organization.configuration.geofence_time_clock
    // ) {
    //   return null;
    // }
    return (
      <SidebarListItem key={index} collapse>
        <NavLink
          to={view.layout + view.path}
          activeClassName=""
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            handleNavOpen();
          }}
        >
          <SingleCollapseLinkContainer
            style={{ paddingLeft: "10px" }}
            active={activeRoute(view.layout + view.path, location)}
            sidebarMini={sidebarMini}
          >
            <CollapseLinkIcon>{view.mini}</CollapseLinkIcon>
            <CollapseLinkText
              active={activeRoute(view.layout + view.path, location)}
            >
              {t(view.name)}
            </CollapseLinkText>
            {view.new && <NewBadge>{view.beta ? "BETA" : "NEW"}</NewBadge>}
          </SingleCollapseLinkContainer>
        </NavLink>
      </SidebarListItem>
    );
  });
};

export const getLinkView = (
  organization,
  path,
  index,
  collapseState,
  setCollapseState,
  location,
  sidebarMini,
  t,
  handleNavOpen,
  quickActionsState,
  setQuickActionsState,
  quickActionsAnchorRef,
) => {
  const imageMap = {
    quickActionsIcon: {
      filled: QuickActionsIconFilled,
      line: QuickActionsIconLine,
    },
    dashboardIcon: { filled: DashboardIconFilled, line: DashboardIconLine },
    remoteTrackIcon: { filled: RemoteTrackIcon, line: RemoteTrackIcon },
    timesheetIcon: { filled: TimesheetIconFilled, line: TimesheetIconLine },
    reportsIcon: { filled: ReportsIcon, line: ReportsIcon },
    clockInOutIcon: { filled: ClockInOutIconFilled, line: ClockInOutIconLine },
    officesIcon: { filled: OfficesIconFilled, line: OfficesIconLine },
    tasksIcon: { filled: TasksIconFilled, line: TasksIconLine },
    schedulesIcon: { filled: SchedulesIconFilled, line: SchedulesIconLine },
    gpsTrackIcon: { filled: GPSTrackIconFilled, line: GPSTrackIconLine },
    projectIcon: { filled: ProjectsIconFilled, line: ProjectsIconLine },
    invoiceIcon: { filled: InvoiceIconFilled, line: InvoiceIconLine },
    WorkOrderIcon: { filled: WorkOrderIconFilled, line: WorkOrderIconLine },
    clientsIcon: { filled: ClientsIconFilled, line: ClientsIconLine },
    teamsIcon: { filled: TeamsIconFilled, line: TeamsIconLine },
    membersIcon: { filled: MembersIconFilled, line: MembersIconLine },
    payrollIcon: { filled: PayrollIconFilled, line: PayrollIconLine },
    routeOptimizationIcon: {
      filled: RouteOptimizationIconFilled,
      line: RouteOptimizationIconLine,
    },
    integrationsIcon: {
      filled: IntegrationsIconFilled,
      line: IntegrationsIconLine,
    },
    organizationsIcon: {
      filled: OrganizationsIconFilled,
      line: OrganizationsIconLine,
    },
    settingsIcon: { filled: SettingsIconFilled, line: SettingsIconLine },
  };
  if (path.collapse) {
    let st = {};
    st[path["state"]] = !collapseState[path.state];
    let activeRoutesForCurrentPath = [];
    // Dynamic paths based on organization type (default to "operation" if not defined)
    const orgType = organization?.type || "operation";
    const isOperationType = orgType === "operation";
    if (path.name === "Jobs" || path.name === "Tasks") {
      if (isOperationType) {
        activeRoutesForCurrentPath = [
          "/user/create-job",
          "/user/job-details",
          "/user/edit-job",
        ];
      } else {
        activeRoutesForCurrentPath = [
          "/user/create-task",
          "/user/task-details",
          "/user/edit-task",
        ];
      }
    }
    // Prevent /jobs-in-map and /tasks-in-map from activating the Jobs/Tasks collapse
    const isMapRoute = location.pathname === "/user/jobs-in-map" || location.pathname === "/user/tasks-in-map";
    const active =
      (getCollapseInitialState(path.views) ||
      checkCollapsePathActiveRoutes(location, activeRoutesForCurrentPath)) && !isMapRoute;
    const isParentRouteActive = activeRoute(path.layout + path.path, location);
    const isParentWithActiveChild = active && !isParentRouteActive;
    return (
      <SidebarCollapseListItem
        key={index}
        collapse
        active={active}
        isParentWithActiveChild={isParentWithActiveChild}
      >
        <SidebarLink
          active={active}
          aria-expanded={collapseState[path.state]}
          onClick={e => {
            e.preventDefault();
            setCollapseState(st);
          }}
        >
          {path.icon !== undefined && (
            <SingleLinkContainer
              sidebarMini={sidebarMini}
              active={active}
              isParentWithActiveChild={isParentWithActiveChild}
            >
              {path.live ? (
                <PulsatingDot
                  active={active}
                  size="10px"
                  margin="10px 7px 7px 9px"
                />
              ) : (
                <LinkIcon
                  src={
                    active
                      ? imageMap[path.icon]?.filled || imageMap[path.icon]?.line
                      : imageMap[path.icon]?.line || imageMap[path.icon]?.filled
                  }
                  alt=""
                />
              )}

              <LinkText
                active={activeRoute(path.layout + path.path, location)}
                isParentWithActiveChild={isParentWithActiveChild}
              >
                {t(path.name)}
              </LinkText>
              {path.new && <NewBadge>{path.beta ? "BETA" : "NEW"}</NewBadge>}
              <CollapseArrowIcon
                src={arrowDown}
                alt=""
                collapsed={!collapseState[path.state]}
              />
            </SingleLinkContainer>
          )}
        </SidebarLink>
        <SidebarLinkCollapse isOpen={collapseState[path.state]}>
          <SidebarCollapseList sidebarMini={sidebarMini}>
            {getCollapseLinks(
              organization,
              path.views,
              location,
              sidebarMini,
              t,
              handleNavOpen,
            )}
          </SidebarCollapseList>
        </SidebarLinkCollapse>
      </SidebarCollapseListItem>
    );
  }

  // Handle Quick Actions path specially - it should open a panel instead of navigating
  if (path.path === "/quick-actions") {
    return (
      <SidebarListItem key={index} active={false} name={path.name}>
        <NavLink
          to="#"
          activeClassName=""
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (setQuickActionsState) {
              setQuickActionsState(prev => ({
                isOpen: !Boolean(prev?.isOpen),
              }));
            }
          }}
          ref={quickActionsAnchorRef}
        >
          {path.icon !== undefined && (
            <SingleLinkContainer
              active={false}
              name={path.name}
              sidebarMini={sidebarMini}
            >
              <LinkIcon
                src={imageMap[path.icon]?.line || imageMap[path.icon]?.filled}
                alt=""
              />
              <LinkText active={false}>{t(path.name)}</LinkText>
              {path.new && <NewBadge>{path.beta ? "BETA" : "NEW"}</NewBadge>}
            </SingleLinkContainer>
          )}
        </NavLink>
      </SidebarListItem>
    );
  }

  return (
    <SidebarListItem
      key={index}
      active={activeRoute(path.layout + path.path, location)}
      name={path.name}
    >
      <NavLink
        to={path.layout + path.path}
        activeClassName=""
        onClick={() => {
          document.documentElement.classList.toggle("nav-open");
          handleNavOpen();
        }}
      >
        {path.icon !== undefined && (
          <SingleLinkContainer
            active={activeRoute(path.layout + path.path, location)}
            name={path.name}
            sidebarMini={sidebarMini}
          >
            {path.live ? (
              <PulsatingDot
                active={activeRoute(path.layout + path.path, location)}
                size="10px"
                margin="10px 7px 7px 9px"
              />
            ) : (
              <LinkIcon
                src={
                  activeRoute(path.layout + path.path, location)
                    ? imageMap[path.icon]?.filled || imageMap[path.icon]?.line
                    : imageMap[path.icon]?.line || imageMap[path.icon]?.filled
                }
                alt=""
              />
            )}
            <LinkText active={activeRoute(path.layout + path.path, location)}>
              {t(path.name)}
            </LinkText>
            {path.new && <NewBadge>{path.beta ? "BETA" : "NEW"}</NewBadge>}
          </SingleLinkContainer>
        )}
      </NavLink>
    </SidebarListItem>
  );
};

export const SeeMoreView = props => {
  const [isSeeMoreOpen, setIsSeeMoreOpen] = useState(false);
  useEffect(() => {
    if (props.sidebarMini) {
      setIsSeeMoreOpen(true);
    }
  }, [props.sidebarMini]);

  return (
    <SeeMoreContainer>
      {!props.sidebarMini &&(<SeeMoreDiv
        onClick={() => setIsSeeMoreOpen(!isSeeMoreOpen)}
        isActive={isSeeMoreOpen}
      >
          <LinkText>See More</LinkText>
        <SeeMoreArrow src={arrowDown} alt="" collapsed={!isSeeMoreOpen} />
      </SeeMoreDiv>)}
      <SidebarLinkCollapse isOpen={isSeeMoreOpen}>
        <SidebarCollapseList
          sidebarMini={props.sidebarMini}
          style={{ marginTop: "5px" }}
        >
          {seeMoreData.map((item, index) => (
            <SidebarListItem
              key={index}
              sidebarMini={props.sidebarMini}
              active={
                !item.isExternal &&
                activeRoute(item.link, props.location) &&
                item.Highlight
              }
            >
              {item.isExternal ? (
                <SidebarLink
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    document.documentElement.classList.toggle("nav-open");
                    props.handleNavOpen();
                  }}
                >
                  <SingleLinkContainer sidebarMini={props.sidebarMini}>
                    <LinkIcon
                      src={item.icon}
                      alt=""
                      style={{marginLeft: props.sidebarMini ? "16px" : "-3px"}}
                    />
                    <LinkText>{item.name}</LinkText>
                    {item.new && (
                      <NewBadge>{item.beta ? "BETA" : "NEW"}</NewBadge>
                    )}
                  </SingleLinkContainer>
                </SidebarLink>
              ) : (
                props.organization &&
                props.organization.role !== "member" && (
                  <NavLink
                    to={item.link}
                    activeClassName=""
                    onClick={() => {
                      document.documentElement.classList.toggle("nav-open");
                      props.handleNavOpen();
                    }}
                  >
                    <SingleLinkContainer>
                      <LinkIcon
                        src={item.icon}
                        alt=""
                        style={{ marginLeft: "-3px" }}
                      />
                      <LinkText>{item.name}</LinkText>
                      {item.new && (
                        <NewBadge>{item.beta ? "BETA" : "NEW"}</NewBadge>
                      )}
                    </SingleLinkContainer>
                  </NavLink>
                )
              )}
            </SidebarListItem>
          ))}
        </SidebarCollapseList>
      </SidebarLinkCollapse>
    </SeeMoreContainer>
  );
};
